import {
  NetworkActivityTimeframeType,
  NetworkTopThreadStarterSenderFilter,
  TopNetworkAnnouncementSortOrder,
  TopNetworkGroupSortOrder,
  TopNetworkThemeThreadSortOrder,
  TopNetworkThreadSortOrder,
} from '@ms/yammer-graphql';

import { create } from '../createOverridableMock';

import { AnalyticsSettings } from './types';

export const defaultAnalyticsSettings: AnalyticsSettings = {
  selectedOnBehalfOfUserId: undefined,
  selectedGroupId: undefined,
  networkActivitySettings: {
    timeframe: NetworkActivityTimeframeType.TWENTY_EIGHT_DAYS,
    topThreadStarterSenderFilter: NetworkTopThreadStarterSenderFilter.ALL_USERS,
    topNetworkAnnouncementSortOrder: TopNetworkAnnouncementSortOrder.VIEW_COUNT_DESC,
    topNetworkGroupSortOrder: TopNetworkGroupSortOrder.POST_COUNT_DESC,
    topNetworkThemeThreadSortOrder: TopNetworkThemeThreadSortOrder.VIEW_COUNT_DESC,
    topNetworkThreadSortOrder: TopNetworkThreadSortOrder.VIEW_COUNT_DESC,
    isRetentionCardCollapsed: false,
  },
};

export const createMockAnalyticsSettings = create<AnalyticsSettings>(defaultAnalyticsSettings);
